<template>
    <div @click="open('/sign-up')" class="call-to-action shape bg-navy border-radius p-4">
        <div class="call-to-action__content">
            <div class="call-to-action__heading mb-2">Become a member today.</div>
            <p class="call-to-action__paragraph mb-12px">If you’re an EOD Technician or someone with a Technical
                Interest then sign up today for access to additional technical information and downloadable
                data.</p>
            <a class="btn-icon-text" href="/sign-up">Get started today <i class="icon icon__arrow-right"></i></a>
        </div>
    </div>
</template>

<script>
    export default {
        name: "CatUxoCallToAction",
        props: [],
        methods: {
            open(url) {
                window.open(url, '_self');
            }
        },
        mounted() {
        }
    }
</script>

<style lang="scss" scoped>
    .call-to-action {
        &__paragraph {
            color: $c-white;
        }
    }
    @include media-breakpoint-down(lg) {
        .call-to-action {
            &:before,
            &:after {
                display: none;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// resources/js/components/CallToAction.vue